"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/ProgramOutline.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_attrs0 = {
        "class": "card"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "col-3 d-flex"
      },
    marko_attrs3 = {
        "class": "col"
      },
    marko_attrs4 = {
        "class": "card-body"
      },
    marko_attrs5 = {
        "class": "card-text text-ellipsis-2 font-medium-3"
      },
    marko_attrs6 = {
        "class": "font-small-3 text-ellipsis-2 text-muted"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("effbe2"),
    marko_node0 = marko_createElement("div", {
        "class": "font-small-3 text-primary mt-2"
      }, "9", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("2 days");

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Card(out) {
    out.be("div", marko_attrs0, "0", component);

    out.be("div", marko_attrs1, "1", component);

    Row_tag({
        class: "m-0 no-gutters d-flex align-items-stretch",
        renderBody: function(out) {
          out.be("div", marko_attrs2, "3", component);

          Image_tag({
              alt: input.title,
              src: input.poster,
              class: "w-100 rounded",
              icon: "bx bxs-landscape"
            }, out, __component, "4");

          out.ee();

          out.e("div", marko_attrs3, "5", component, 1)
            .e("div", marko_attrs4, "6", component, 3)
              .e("div", marko_attrs5, "7", component, 1)
                .t(input.title, component)
              .e("div", marko_attrs6, "8", component, 1)
                .t(input.description, component)
              .n(marko_node0, component);
        }
      }, out, __component, "2");

    out.ee();

    out.ee();
  }

  if (input.link) {
    route_link_tag({
        href: link,
        renderBody: function(out) {
          marko_dynamicTag(out, macro_Card, null, null, null, null, __component, "11");
        }
      }, out, __component, "10");
  } else {
    marko_dynamicTag(out, macro_Card, null, null, null, null, __component, "12");
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
